import {
  IconButton,
  IconButtonProps,
  ListItemText,
  ListItemTextProps,
  Menu,
  MenuItem,
  MenuItemProps,
  MenuProps
} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import React from 'react'

export const DropdownMenu: React.FC<MenuProps> = props => {
  const muiPaperStyles = (props?.sx as { '& .MuiMenu-paper': Record<string, string> })?.[
    '& .MuiMenu-paper'
  ]
  return (
    <Menu
      {...props}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
        ...props?.anchorOrigin
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
        ...props?.transformOrigin
      }}
      sx={{
        ...props?.sx,
        '& .MuiMenu-paper': {
          ...muiPaperStyles,
          borderRadius: '12px',
          boxShadow: '3px 3px 30px rgba(17, 17, 17, 0.1)'
        }
      }}
    >
      {props.children}
    </Menu>
  )
}

export const DropdownItem: React.FC<MenuItemProps> = React.forwardRef<HTMLLIElement, MenuItemProps>(
  (props, ref) => {
    return (
      <MenuItem
        {...props}
        ref={ref}
        disableRipple={true}
        sx={{
          ...props?.sx,
          '&.Mui-selected': {
            backgroundColor: 'white',
            '&:focus': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
          },
          '&:focus': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          }
        }}
      />
    )
  }
)
DropdownItem.displayName = 'DropdownItem'

export const DropdownItemText: React.FC<ListItemTextProps> = ({ children, sx }) => {
  const muiListItemTextStyles = (sx as { '& .MuiListItemText-primary': Record<string, string> })?.[
    '& .MuiListItemText-primary'
  ]
  return (
    <ListItemText
      sx={{
        ...sx,
        '& .MuiListItemText-primary': {
          fontWeight: 'bold',
          fontSize: '16px',
          ...muiListItemTextStyles
        }
      }}
    >
      {children}
    </ListItemText>
  )
}

export const MobileDropdownButton: React.FC<IconButtonProps> = React.forwardRef<
  HTMLButtonElement,
  IconButtonProps
>((props, ref) => {
  return (
    <IconButton ref={ref} {...props} sx={{ width: '50px', height: '50px' }}>
      <MoreVertIcon />
    </IconButton>
  )
})
MobileDropdownButton.displayName = 'MobileDropdownButton'
